module.exports = __webpack_public_path__ + "img/36_fineStaff_zyb.aebf5ce3.png";